import { createSlice } from "@reduxjs/toolkit";

const ARCHIVE_PREFIX = "__ARCHIVED__::";

const initialState = {
  allCustomers: [],
  customers: [],
  customerDetail: null,
  filteredCustomers: [],
  allCustomersLoaded: false,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setAllCustomers(state, action) {
      state.allCustomers = action.payload;
      state.allCustomersLoaded = true;
      const active = action.payload.filter(
        (c) => !(c.status || "").startsWith(ARCHIVE_PREFIX)
      );
      state.customers = active;
      state.filteredCustomers = active;
    },
    updateCustomerStatus(state, action) {
      const { id, status } = action.payload;
      const idx = state.allCustomers.findIndex((c) => c.id === id);
      if (idx !== -1) {
        state.allCustomers[idx] = { ...state.allCustomers[idx], status };
      }
      const active = state.allCustomers.filter(
        (c) => !(c.status || "").startsWith(ARCHIVE_PREFIX)
      );
      state.customers = active;
      state.filteredCustomers = active;
    },
    setCustomers(state, action) {
      state.customers = action.payload;
      state.filteredCustomers = action.payload;
    },
    setCustomerDetail(state, action) {
      state.customerDetail = action.payload;
    },
    setFilteredCustomers(state, action) {
      state.filteredCustomers = action.payload;
    },
    applyFilters(state, action) {
      const { filters } = action.payload;

      let filteredData = state.customers;

      if (filters.assigned && filters.assigned !== "All") {
        filteredData = filteredData.filter(
          (customer) => customer.assigned_to === filters.assigned
        );
      }

      if (filters.serviceType && filters.serviceType !== "All") {
        filteredData = filteredData.filter(
          (customer) =>
            customer.subservice_name.includes(filters.serviceType) ===
            filters.serviceType
        );
      }

      if (filters.branch && filters.branch !== "All") {
        filteredData = filteredData.filter(
          (customer) => customer.branch === filters.branch
        );
      }
      if (filters.intake && filters.intake !== "All") {
        filteredData = filteredData.filter(
          (customer) => customer.intake === filters.intake
        );
      }

      if (filters.country && filters.country !== "All") {
        filteredData = filteredData.filter((customer) =>
          customer.preferred_countries?.includes(filters.country)
        );
      }

      if (filters.intendedDegree && filters.intendedDegree !== "All") {
        filteredData = filteredData.filter(
          (customer) => customer.intended_degree === filters.intendedDegree
        );
      }

      if (filters.fromDate) {
        const fromDate = new Date(filters.fromDate);
        filteredData = filteredData.filter(
          (customer) => new Date(customer.created_at) >= fromDate
        );
      }

      if (filters.toDate) {
        const toDate = new Date(filters.toDate);
        filteredData = filteredData.filter(
          (customer) => new Date(customer.created_at) <= toDate
        );
      }

      state.filteredCustomers = filteredData;
    },
  },
});

export const {
  setAllCustomers,
  updateCustomerStatus,
  setCustomers,
  setCustomerDetail,
  setFilteredCustomers,
  applyFilters,
} = customerSlice.actions;

export default customerSlice.reducer;
